import { ApiService } from "@/api";

export default {
  GET_LIST_SIP_SERVERS({ commit }, payload) {
    return ApiService.sip_servers
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_SIP_SERVERS", data));
  },
  GET_LIST_SIP_SERVERS_SELECT({ commit }, payload) {
    return ApiService.sip_servers
      .getListSelect({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_SIP_SERVERS", data));
  },
  GET_LIST_SIP_SERVERS_APPEND({ commit }, payload) {
    return ApiService.sip_servers
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => {
        commit("SET_LIST_SIP_SERVERS_APPEND", data);
        return data;
      });
  },
};
